import { createSlice } from "@reduxjs/toolkit";
import { IInventoryRequest } from "../../../interfaces/apiInterface";
import {
  addInventoryIssueDataAll,
  createInventoryRequest,
  deleteInventoryReqsItem,
  deleteInventoryRequest,
  editInventoryReqsItem,
  editInventoryRequest,
  getAllInventoryAllPo,
  getAllInventoryItem,
  getAllInventoryRequest,
  getInventoryAllPo,
  getInventoryReqsById,
  getInventoryReqsPdf,
  getInventoryRequestDataAll,
  getInventoryStore,
  getItemFromStore,
  markInventoryReqsAuthorize,
  grnAdd,
  getAllRequestedItem,
  addInventoryAddPo,
  poInventoryUpdate,
  getAllInventoryRequestForExcel,
  getAllRequestedItemForExcel,
  getInventoryAllPoExcel,
  getInventoryRequestDataAllForExcel,
  createDirectGrnRequest,
} from "./inventoryRequestAsyncActions";

export const initialState: IInventoryRequest = {
  isLoading: false,
  inventoryItemData: [],
  inventoryRequestData: [],
  requestInfo: {},
  requestDetail: {},
  requestItemInfo: {},
  requestPdfData: {},
  inventoryStoreData: [],
  inventoryReqStore: {},
  inventoryReqSource: "",
  error: null,
  inventoryIssueData: [],
  issueCheckStatus: [],
  inventoryPoData: [],
  poCheckStatus: [],
  getAlldirectPoData: [],
  getItemWithStoreData: [],
  getAllInventoryRequestData: [],
  raiseDirectPoData: [],
  directPoStatus: [],
  inventoryReqSourceDept: "",
  inventoryReqSourceRoom: "",
  poFormData: [],
  getIssueId: "",
  getAllInventoryPurchaseOrderData: [],
  selectedPurchaseOrderList: [],
  addTestText: [],
  addGrn: [],
  inventoryRequestDataInfo: {},
  requestSourceTypeEvent: "",
  requestSourceEvent: "",
  inventoryReqSourceBranch: {},
  fetchPoId: "",
  addedInventoryRequests: [],
  inventoryUniquePoData: [],
  allRequestedItem: [],
  inventoryLoader: false,
  directGrnSelectedList: [],
};

export const InventoryRequestSlice = createSlice({
  name: "inventory",
  initialState,
  reducers: {
    getInventoryReqSource: (state, action) => {
      state.inventoryReqSource = action.payload;
    },
    clearInventoryReqSource: (state) => {
      state.inventoryReqSource = "";
      state.inventoryReqSource = "";
    },
    getInventoryReqSourceBranch: (state, action) => {
      state.inventoryReqSourceBranch = action.payload;
    },
    clearInventoryReqSourceBranch: (state) => {
      state.inventoryReqSourceBranch = {};
    },
    getInventoryReqStore: (state, action) => {
      state.inventoryReqStore = action.payload;
    },
    clearInventoryReqStore: (state) => {
      state.inventoryReqStore = {};
    },
    clearInventoryPurchaseOrderData: (state) => {
      state.selectedPurchaseOrderList = [];
    },
    clearPendingPoData: (state) => {
      state.getAllInventoryPurchaseOrderData = [];
    },
    updatePendingPoData: (state, action) => {
      state.selectedPurchaseOrderList = action.payload;
    },
    updategetAllInventoryPoData: (state, action) => {
      state.getAllInventoryPurchaseOrderData = action.payload;
    },
    getInventoryReqSourceDept: (state, action) => {
      state.inventoryReqSourceDept = action.payload;
    },
    clearInventoryReqSourceDept: (state) => {
      state.inventoryReqSourceDept = "";
    },
    getInventoryReqSourceRoom: (state, action) => {
      state.inventoryReqSourceRoom = action.payload;
    },
    clearInventoryReqSourceRoom: (state) => {
      state.inventoryReqSourceRoom = "";
    },
    getInventoryIssueData: (state, action) => {
      state.inventoryIssueData = [...state.inventoryIssueData, action.payload];
    },
    removeInventoryIssueData: (state, action) => {
      state.inventoryIssueData.splice(action.payload, 1);
    },
    updateInventoryIssueData: (state, action) => {
      state.inventoryIssueData = action.payload;
    },
    clearInventoryIssueData: (state) => {
      state.inventoryIssueData = [];
    },
    getInventoryPoData: (state, action) => {
      state.inventoryPoData = [...state.inventoryPoData, action.payload];
      state.poCheckStatus = [...state.poCheckStatus, action.payload];
    },
    getDirectPoData: (state, action) => {
      state.inventoryPoData = [...state.inventoryPoData, action.payload];
      state.directPoStatus = [...state.directPoStatus, action.payload];
    },
    updateInventoryPoData: (state, action) => {
      state.inventoryPoData = action.payload;
    },
    removeInventoryPoData: (state, action) => {
      state.inventoryPoData = state.inventoryPoData.filter(
        (item) => item._id !== action.payload
      );
      state.poCheckStatus = state.poCheckStatus.filter(
        (item: any) => item._id !== action.payload
      );
    },
    removeDirectPoData: (state, action) => {
      state.inventoryPoData = state.inventoryPoData.filter(
        (item) => item._id !== action.payload
      );
      state.directPoStatus = state.directPoStatus.filter(
        (item: any) => item._id !== action.payload
      );
    },
    setIssueCheckStatus: (state, action) => {
      const index = state.issueCheckStatus.indexOf(action.payload);
      if (index > -1) {
        state.issueCheckStatus.splice(index, 1);
      } else {
        state.issueCheckStatus.push(action.payload);
      }
    },
    emptyIssueCheckStatus: (state) => {
      state.issueCheckStatus = [];
    },
    setPoCheckStatus: (state, action) => {
      const index = state.poCheckStatus.indexOf(action.payload);
      if (index > -1) {
        state.poCheckStatus.splice(index, 1);
      } else {
        state.poCheckStatus.push(action.payload);
      }
    },
    setDirectPoStatus: (state, action) => {
      const index = state.directPoStatus.indexOf(action.payload);
      if (index > -1) {
        state.directPoStatus.splice(index, 1);
      } else {
        state.directPoStatus.push(action.payload);
      }
    },
    deleteDirectPoData: (state, action) => {
      const removedDirectPoStatus = state.directPoStatus?.filter(
        (item: any) => action.payload?.item_id !== item?.item_id
      );
      const removedPoCheckStatus = state.poCheckStatus?.filter(
        (item: any) => action.payload?.item_id !== item?.item_id
      );
      const removedInventoryPoData = state.inventoryPoData?.filter(
        (item: any) => action.payload?.item_id !== item?.item_id
      );
      const removedinventoryUniquePoData = state.inventoryUniquePoData?.filter(
        (item: any) => action.payload?.item_id !== item?.item_id
      );
      state.directPoStatus = removedDirectPoStatus;
      state.poCheckStatus = removedPoCheckStatus;
      state.inventoryPoData = removedInventoryPoData;
      state.inventoryUniquePoData = removedinventoryUniquePoData;
    },
    updateDirectPoStatus: (state, action) => {
      state.directPoStatus = action.payload;
    },
    updatePoCheckStatus: (state, action) => {
      state.poCheckStatus = action.payload;
    },
    getPoFormData: (state, action) => {
      state.poFormData = action.payload;
    },
    updatePoFormData: (state, action) => {
      state.poFormData = action.payload;
    },
    emptyPoFormData: (state) => {
      state.poFormData = [];
    },
    updateAllPoData: (state, action) => {
      state.inventoryPoData = action.payload;
    },
    setIssueId: (state, action) => {
      state.getIssueId = action.payload;
    },
    setPurchaseOrderList: (state, action) => {
      state.selectedPurchaseOrderList = [
        ...state.selectedPurchaseOrderList,
        action.payload,
      ];
    },

    setAddText: (state: any, action: any) => {
      const index = state.addTestText.indexOf(action.payload);
      if (index > -1) {
        state.addTestText.splice(index, 1);
      } else {
        state.addTestText.push(action.payload);
      }
    },
    removeFromIPurchaseOrderList: (state, action) => {
      // state.selectedPurchaseOrderList = state.selectedPurchaseOrderList.filter(
      //   (item: any) => {
      //     return item._id !== action.payload;
      //   }
      // );
      state.selectedPurchaseOrderList.splice(action.payload, 1);
    },

    emptyAllPoData: (state) => {
      state.addTestText = [];
    },
    setRequestSourceTypeEvent: (state, action) => {
      state.requestSourceTypeEvent = action.payload;
    },
    setRequestSourceEvent: (state, action) => {
      state.requestSourceEvent = action.payload;
    },
    setFetchPoId: (state, action) => {
      state.fetchPoId = action.payload;
    },
    addedInventoryRequestData: (state, action) => {
      state.addedInventoryRequests = action.payload;
    },
    setInventoryUniquePoData: (state, action) => {
      state.inventoryUniquePoData = action.payload;
    },

    setDirectGrnPopupData: (state, action) => {
      state.directGrnSelectedList = [
        ...state.directGrnSelectedList,
        action.payload,
      ];
    },
    removeDirectGrnPopupData: (state, action) => {
      state.directGrnSelectedList = state.directGrnSelectedList.filter(
        (item) => {
          return item?._id !== action.payload;
        }
      );
    },
    updateGrnMainStoreTableData: (state, action) => {
      state.directGrnSelectedList = action.payload;
    },
    clearDirectGrnSelectedList: (state) => {
      state.directGrnSelectedList = [];
    },
  },
  extraReducers: (builder) => {
    // GET ALL INVENTORY ITEM

    builder.addCase(getAllInventoryItem.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getAllInventoryItem.fulfilled, (state, action) => {
      state.isLoading = false;
      state.inventoryItemData = action.payload?.data;
    });
    builder.addCase(getAllInventoryItem.rejected, (state, error) => {
      state.isLoading = false;
      state.error = error;
    });

    // CREATE INVENTORY REQUEST

    builder.addCase(createInventoryRequest.pending, (state) => {
      state.isLoading = true;
      state.inventoryLoader = true;
    });
    builder.addCase(createInventoryRequest.fulfilled, (state, action) => {
      state.isLoading = false;
      state.inventoryLoader = false;
      state.requestInfo = action.payload;
    });
    builder.addCase(createInventoryRequest.rejected, (state, error) => {
      state.isLoading = false;
      state.inventoryLoader = false;
      state.error = error;
    });

    // EDIT INVENTORY REQUEST

    builder.addCase(editInventoryRequest.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(editInventoryRequest.fulfilled, (state, action) => {
      state.isLoading = false;
      state.requestInfo = action.payload;
    });
    builder.addCase(editInventoryRequest.rejected, (state, error) => {
      state.isLoading = false;
      state.error = error;
    });

    // DELETE INVENTORY REQUEST

    builder.addCase(deleteInventoryRequest.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(deleteInventoryRequest.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(deleteInventoryRequest.rejected, (state, error) => {
      state.isLoading = false;
      state.error = error;
    });

    // GET ALL INVENTORY REQUEST

    builder.addCase(getAllInventoryRequest.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getAllInventoryRequest.fulfilled, (state, action) => {
      state.isLoading = false;
      state.inventoryRequestData = action.payload?.data;
      state.inventoryRequestDataInfo = action.payload;
    });
    builder.addCase(getAllInventoryRequest.rejected, (state, error) => {
      state.isLoading = false;
      state.error = error;
    });

    // GET INVENTORY REQUEST BY ID

    builder.addCase(getInventoryReqsById.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getInventoryReqsById.fulfilled, (state, action) => {
      state.isLoading = false;
      state.requestDetail = action.payload;
    });
    builder.addCase(getInventoryReqsById.rejected, (state, error) => {
      state.isLoading = false;
      state.error = error;
    });

    // MARK INVENTORY REQUEST AUTHORIZE

    builder.addCase(markInventoryReqsAuthorize.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(markInventoryReqsAuthorize.fulfilled, (state) => {
      state.isLoading = false;
    });
    builder.addCase(markInventoryReqsAuthorize.rejected, (state, error) => {
      state.isLoading = false;
      state.error = error;
    });

    // GET INVENTORY REQUEST PDF

    builder.addCase(getInventoryReqsPdf.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getInventoryReqsPdf.fulfilled, (state, action) => {
      state.isLoading = false;
      state.requestPdfData = action.payload;
    });
    builder.addCase(getInventoryReqsPdf.rejected, (state, error) => {
      state.isLoading = false;
      state.error = error;
    });

    // EDIT INVENTORY REQUEST ITEM

    builder.addCase(editInventoryReqsItem.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(editInventoryReqsItem.fulfilled, (state, action) => {
      state.isLoading = false;
      state.requestItemInfo = action.payload;
    });
    builder.addCase(editInventoryReqsItem.rejected, (state, error) => {
      state.isLoading = false;
      state.error = error;
    });

    // DELETE INVENTORY REQUEST ITEM

    builder.addCase(deleteInventoryReqsItem.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(deleteInventoryReqsItem.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(deleteInventoryReqsItem.rejected, (state, error) => {
      state.isLoading = false;
      state.error = error;
    });

    // GET INVENTORY STORE

    builder.addCase(getInventoryStore.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getInventoryStore.fulfilled, (state, action) => {
      state.isLoading = false;
      state.inventoryStoreData = action.payload;
    });
    builder.addCase(getInventoryStore.rejected, (state, error) => {
      state.isLoading = false;
      state.error = error;
    });

    // GET INVENTORY P0 Mainstore Data

    builder.addCase(getInventoryAllPo.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getInventoryAllPo.fulfilled, (state, action) => {
      state.isLoading = false;
      state.getAlldirectPoData = action.payload?.data;
    });
    builder.addCase(getInventoryAllPo.rejected, (state, error) => {
      state.isLoading = false;
      state.error = error;
    });

    builder.addCase(getInventoryAllPoExcel.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getInventoryAllPoExcel.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(getInventoryAllPoExcel.rejected, (state, error) => {
      state.isLoading = false;
      state.error = error;
    });

    // GET ITEMS FROM STORE

    builder.addCase(getItemFromStore.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getItemFromStore.fulfilled, (state, action) => {
      state.isLoading = false;
      state.getItemWithStoreData = action.payload?.data;
    });
    builder.addCase(getItemFromStore.rejected, (state, error) => {
      state.isLoading = false;
      state.error = error;
    });

    // GET INVENTORY DATA

    builder.addCase(getInventoryRequestDataAll.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getInventoryRequestDataAll.fulfilled, (state, action) => {
      state.isLoading = false;
      state.getAllInventoryRequestData = action.payload?.data;
    });
    builder.addCase(getInventoryRequestDataAll.rejected, (state, error) => {
      state.isLoading = false;
      state.error = error;
    });

    builder.addCase(getInventoryRequestDataAllForExcel.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(
      getInventoryRequestDataAllForExcel.fulfilled,
      (state, action) => {
        state.isLoading = false;
      }
    );
    builder.addCase(
      getInventoryRequestDataAllForExcel.rejected,
      (state, error) => {
        state.isLoading = false;
        state.error = error;
      }
    );

    //ADD ISSUE DATA MAINSTORE
    builder.addCase(addInventoryIssueDataAll.pending, (state) => {
      state.isLoading = true;
      state.inventoryLoader = true;
    });
    builder.addCase(addInventoryIssueDataAll.fulfilled, (state, action) => {
      state.isLoading = false;
      state.inventoryLoader = false;
    });
    builder.addCase(addInventoryIssueDataAll.rejected, (state, error) => {
      state.isLoading = false;
      state.inventoryLoader = false;
      state.error = error;
    });
    // GET PURCHASE ORDER  DATA
    builder.addCase(getAllInventoryAllPo.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getAllInventoryAllPo.fulfilled, (state, action) => {
      state.isLoading = false;
      state.getAllInventoryPurchaseOrderData = action.payload?.data;
    });
    builder.addCase(getAllInventoryAllPo.rejected, (state, error) => {
      state.isLoading = false;
      state.error = error;
    });

    //ADD GRN

    builder.addCase(grnAdd.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(grnAdd.fulfilled, (state, action) => {
      state.isLoading = false;
      state.addGrn = action.payload;
    });
    builder.addCase(grnAdd.rejected, (state, error) => {
      state.isLoading = false;
      state.error = error;
    });

    // GET ALL INVENTORY REQUESTED ITEMS

    builder.addCase(getAllRequestedItem.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getAllRequestedItem.fulfilled, (state, action) => {
      state.isLoading = false;
      state.allRequestedItem = action.payload?.data;
    });
    builder.addCase(getAllRequestedItem.rejected, (state, error) => {
      state.isLoading = false;
      state.error = error;
    });

    // CONFIRM PO CREATE

    builder.addCase(addInventoryAddPo.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(addInventoryAddPo.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(addInventoryAddPo.rejected, (state, error) => {
      state.isLoading = false;
      state.error = error;
    });

    // CONFIRM PO UPDAYE

    builder.addCase(poInventoryUpdate.pending, (state) => {
      state.inventoryLoader = true;
    });
    builder.addCase(poInventoryUpdate.fulfilled, (state, action) => {
      state.inventoryLoader = false;
    });
    builder.addCase(poInventoryUpdate.rejected, (state, error) => {
      state.inventoryLoader = false;
      state.error = error;
    });

    builder.addCase(getAllInventoryRequestForExcel.pending, (state) => {
      state.inventoryLoader = true;
    });
    builder.addCase(
      getAllInventoryRequestForExcel.fulfilled,
      (state, action) => {
        state.inventoryLoader = false;
      }
    );
    builder.addCase(getAllInventoryRequestForExcel.rejected, (state, error) => {
      state.inventoryLoader = false;
      state.error = error;
    });

    builder.addCase(getAllRequestedItemForExcel.pending, (state) => {
      state.inventoryLoader = true;
    });
    builder.addCase(getAllRequestedItemForExcel.fulfilled, (state, action) => {
      state.inventoryLoader = false;
    });
    builder.addCase(getAllRequestedItemForExcel.rejected, (state, error) => {
      state.inventoryLoader = false;
      state.error = error;
    });

    // Create Direct GRN
    builder.addCase(createDirectGrnRequest.pending, (state) => {
      state.inventoryLoader = true;
    });
    builder.addCase(createDirectGrnRequest.fulfilled, (state, action) => {
      state.inventoryLoader = false;
    });
    builder.addCase(createDirectGrnRequest.rejected, (state, error) => {
      state.inventoryLoader = false;
      state.error = error;
    });
  },
});

export const {
  clearInventoryReqStore,
  getInventoryReqStore,
  clearInventoryReqSource,
  getInventoryReqSource,
  getInventoryIssueData,
  setIssueCheckStatus,
  removeInventoryIssueData,
  getInventoryPoData,
  removeInventoryPoData,
  setPoCheckStatus,
  setDirectPoStatus,
  clearInventoryPurchaseOrderData,
  setPurchaseOrderList,
  removeFromIPurchaseOrderList,
  setAddText,
  clearPendingPoData,
  getInventoryReqSourceDept,
  clearInventoryReqSourceDept,
  getInventoryReqSourceRoom,
  clearInventoryReqSourceRoom,
  updateInventoryIssueData,
  getPoFormData,
  updateAllPoData,
  updatePoFormData,
  setIssueId,
  clearInventoryIssueData,
  updatePendingPoData,
  updategetAllInventoryPoData,
  emptyAllPoData,
  emptyPoFormData,
  setRequestSourceTypeEvent,
  setRequestSourceEvent,
  updateInventoryPoData,
  getInventoryReqSourceBranch,
  clearInventoryReqSourceBranch,
  emptyIssueCheckStatus,
  updateDirectPoStatus,
  setFetchPoId,
  deleteDirectPoData,
  updatePoCheckStatus,
  addedInventoryRequestData,
  setInventoryUniquePoData,
  getDirectPoData,
  removeDirectPoData,
  setDirectGrnPopupData,
  removeDirectGrnPopupData,
  updateGrnMainStoreTableData,
  clearDirectGrnSelectedList
} = InventoryRequestSlice.actions;
export default InventoryRequestSlice.reducer;
